import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=14b79cf4&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=14b79cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b79cf4",
  null
  
)

export default component.exports